export const CHUNK_RELOAD_STORAGE_KEY = "autoplus:chunk-reload";

export type KeyValueStorage = {
  getItem: (key: string) => string | null;
  setItem: (key: string, value: string) => void;
};

type PreloadTarget = {
  addEventListener: (type: string, listener: EventListener) => void;
  location: { reload: () => void };
};

export function isChunkLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error ?? "");
  return (
    /Failed to fetch dynamically imported module/i.test(message) ||
    /Importing a module script failed/i.test(message) ||
    /error loading dynamically imported module/i.test(message)
  );
}

export function shouldReloadForStaleChunk(
  error: unknown,
  storage: KeyValueStorage,
): boolean {
  if (!isChunkLoadError(error)) return false;
  if (storage.getItem(CHUNK_RELOAD_STORAGE_KEY)) return false;
  storage.setItem(CHUNK_RELOAD_STORAGE_KEY, "1");
  return true;
}

export function installVitePreloadErrorHandler(
  target: PreloadTarget,
  storage: KeyValueStorage,
): void {
  target.addEventListener("vite:preloadError", (event) => {
    const payload =
      event && typeof event === "object" && "payload" in event
        ? (event as Event & { payload?: unknown }).payload
        : undefined;
    if (!shouldReloadForStaleChunk(payload ?? event, storage)) return;
    event.preventDefault();
    target.location.reload();
  });
}
